import dateUtils from "../../utils/dateUtils";
import { ICellRender } from "./types";
import { Link } from "react-router-dom";
import ROUTES from "../../routes";
import HrnAvatar from "../../components/HrnAvatar";
import hrnUtils from "../../utils/hrnUtils";

const cells = {
  textCell: function textCell({
    value,
    className,
    leftExtraText,
    rightExtraText,
  }: ICellRender) {
    return (
      <div className={"w-full"}>
        {leftExtraText && `${leftExtraText} `}
        {value} {rightExtraText && `${rightExtraText} `}
      </div>
    );
  },
  badgeCell: function badgeCell({ value }: ICellRender) {
    return <div className="opacity-80">{hrnUtils.badge(value)}</div>;
  },
  dateTimeCell: function dateTimeCell({ value }: ICellRender) {
    return <div className="opacity-80">{dateUtils.lllFormat(value)}</div>;
  },
  listCountCell: function badgeCell({ value }: ICellRender) {
    return <div className="opacity-80">{`${value?.length} item`}{value?.length > 1 ? "s" : ""}</div>;
  },
  companyNameCell: ({ value, record }: ICellRender) => {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`${ROUTES.PATHS.COMPANIES}/${record.id}`}>
          <div className="text-primary font-medium">{value}</div>
        </Link>
      </div>
    );
  },
  surveyNameCell: ({ value, record }: ICellRender) => {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`/${record.id}`}>
          <div className="text-primary font-medium">{value}</div>
        </Link>
      </div>
    );
  },
  applicationTypeNameCell: ({ value, record }: ICellRender) => {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`/${record.id}`}>
          <div className="text-primary font-medium">{value}</div>
        </Link>
      </div>
    );
  },
  userNameCell: ({ value, record }: ICellRender) => {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`/${record.id}`} style={{ whiteSpace: "nowrap" }}>
          <div className="text-primary font-medium">{value}</div>
        </Link>
      </div>
    );
  },
  userAvatarCell: ({ value, record }: ICellRender) => {
    return <HrnAvatar user={record} />;
  },
  userAvatarNameCell: ({ value, record }: ICellRender) => {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`/${record.id}`} className="flex" style={{ whiteSpace: "nowrap" }}>
          <HrnAvatar user={record} /><div className="text-primary font-medium ml-[10px]">{value}</div>
        </Link>
      </div>
    );
  },
  employeeNameCell: function employeeNameCell({ value, record }: ICellRender) {
    return (
      <div className="flex items-center gap-x-2">
        <Link to={`${record.id}`}>
          <HrnAvatar user={record} size={48} />
        </Link>
        <div>
          <div className="text-primary font-medium">{value}</div>
          <div className="opacity-80">{record.designation?.name}</div>
        </div>
      </div>
    );
  },
};

export default cells;
